import styled from 'styled-components/macro'
import { NavLink } from 'react-router-dom'

export const Wrapper = styled.nav`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	border-right: 1px solid ${({ theme }) => theme.colors.grey};
	justify-content: flex-start;
	padding: 30px 0;
	grid-row: 1/3;
	grid-column: 1 /1;
`

export const Logo = styled.div`
	background-color: ${({ theme }) => theme.colors.blue};
	width: 100%;
	height: 60px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-bottom: 30px;

	h1 {
		font-size: 15px;
		color: ${({ theme }) => theme.colors.white};
		text-align: right;
		margin-right: 20px;
	}
`

export const StyledLink = styled(NavLink)`
	position: relative;
	font-weight: bold;
	text-decoration: none;
	color: ${({ theme }) => theme.colors.darkGrey};
	text-align: right;
	margin: 15px 20px 15px auto;

	&.active {
		&::after {
			opacity: 1;
			content: '';
		}
	}

	&::after {
		content: '';
		position: absolute;
		top: 50%;
		right: -20px;
		transform: translateY(-50%);
		width: 18px;
		height: 3px;
		background-color: ${({ theme }) => theme.colors.grey};
		transition: opacity 0.3s ease-in-out;
		opacity: 0;
	}
`
